import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {map} from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { CommonHelper } from '../helpers/common';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

    private url = environment.urlApiRest;
    private language: string = CommonHelper.requestLanguage;

    constructor( private http: HttpClient) {  }

    openpayCharge(data : Object){
        
      let headers = new HttpHeaders({
        'Content-Type':'application/x-www-form-urlencoded'
      });
  
      return this.http.post(`${this.url}payments/openpay/card?is_lmp_live=1&lang=${this.language}`,data,{headers:headers}).pipe(
        map( resp => {
          return resp;
        })
      );
    }
    openpay3DSecure(data : Object){
     
      let headers = new HttpHeaders({
        'Content-Type':'application/x-www-form-urlencoded'
      });
  
      return this.http.post(`${this.url}payments/openpay/security3d?is_lmp_live=1&lang=${this.language}`,data,{headers:headers}).pipe(
        map( resp => {
          return resp;
        })
      );
    }
    getPaymentsByToken(){
      let headers = new HttpHeaders({
        'Content-Type':'application/x-www-form-urlencoded',
        'Authorization': localStorage.getItem('token')
      });
      return this.http.get(`${this.url}payments?lang=${this.language}`,{headers:headers}).pipe( map( resp => {return resp;}));
    }

}
